import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import Card from "../Card";

import Wedding from "../../../assets/images/PersonalizedGifts/WeddingCard.jpg";
import Sunboard from "../../../assets/images/PersonalizedGifts/Sunboard.jpg";
import CutOut from "../../../assets/images/PersonalizedGifts/CartoonCutout.jpg";
import Caps from "../../../assets/images/PersonalizedGifts/Caps.jpg";
import Bottle from "../../../assets/images/PersonalizedGifts/Bottle.jpg";
import Stickers from "../../../assets/images/PersonalizedGifts/Stickers.jpg";

// Card Data
const cardData = [
  { image: Wedding, text: "Invitation Cards" },
  { image: Sunboard, text: "Vinyl Sunboard" },
  { image: CutOut, text: "Cartoon/ Animal Cutouts" },
  { image: Caps, text: "Customized caps" },
  { image: Bottle, text: "Personalized Bottles" },
  { image: Stickers, text: "Stickers" },
];

function KidsFavorite() {
  return (
    <>
      <Container>
        {/* <h2 className="py-4 fw-bold text-center">
          Special for Themed Events!!
        </h2>
        1st row
        <Row className="justify-content-center">
          {cardData.slice(0, 2).map((card, index) => (
            <Col md={3} className="d-flex justify-content-center" key={index}>
              <Card image={card.image} text={card.text} />
            </Col>
          ))}
        </Row> */}
        <h2 className="py-4 fw-bold text-center">Kids Favourites</h2>
        {/* 2nd row */}
        <Row>
          {cardData.slice(2, 6).map((card, index) => (
            <Col md={3} className="d-flex" key={index}>
              <Card image={card.image} text={card.text} />
            </Col>
          ))}
        </Row>
        {/* Divider-line */}
        <hr className="divider-line" style={{ margin: "0 auto" }} />
      </Container>
    </>
  );
}

export default KidsFavorite;
